import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterbyreferenceComponent } from './registerbyreference.component';
import { MatchHeightModule } from 'app/shared/directives/match-height.directive';
import { RegisterRoutingModule } from '../register/register-routing.module';
import { MatButtonModule, MatFormFieldModule, MatInputModule } from '@angular/material';
import { SharedModule } from 'app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { RegisterbyreferenceRoutingModule } from './registerbyreference-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [RegisterbyreferenceComponent],
  imports: [
        CommonModule,        
        MatchHeightModule,
        RegisterbyreferenceRoutingModule,
        MatFormFieldModule,
        MatInputModule,       
        SharedModule,
        MatButtonModule,
        ReactiveFormsModule,
        NgbModule,      
       
  ]
})
export class RegisterbyreferenceModule { }
